// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const DownloadGooglePlay = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 134 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6 0a6 6 0 0 0-6 6v28a6 6 0 0 0 6 6h122a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6H6Z"
			fill="#000"
		/>
		<mask
			id="DownloadGooglePlay_tsx__a"
			mask-type="alpha"
			maskUnits="userSpaceOnUse"
			x={0}
			y={0}
			width={134}
			height={40}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6 0a6 6 0 0 0-6 6v28a6 6 0 0 0 6 6h122a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6H6Z"
				fill="#fff"
			/>
		</mask>
		<g mask="url(#DownloadGooglePlay_tsx__a)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M46.7 12.2c.5-.5.7-1.2.7-2v-.3h-2.9v.7h2.2c0 .5-.2.9-.5 1.2-.5.5-1 .7-1.7.7-.6 0-1.1-.3-1.6-.7-.5-.4-.7-1-.7-1.7s.2-1.3.7-1.7c.4-.5 1-.7 1.6-.7.7 0 1.2.2 1.6.7l.5-.5c-.2-.3-.5-.5-.9-.7-.4-.2-.8-.3-1.2-.3-.9 0-1.6.3-2.2.9-.6.6-.9 1.3-.9 2.2 0 .9.3 1.6.9 2.2.6.6 1.3.9 2.2.9.9 0 1.6-.3 2.2-.9Zm2.6-4.5H52V7h-3.5v6H52v-.8h-2.7v-1.9h2.5v-.7h-2.5V7.7Zm6 5.3h-.8V7.7h-1.7V7H57v.7h-1.7V13Zm5.4-6h-.8v6h.8V7Zm3.3 6h-.7V7.7h-1.7V7h4.1v.7H64V13Zm7.4.1c.9 0 1.6-.3 2.2-.9.6-.6.9-1.3.9-2.2 0-.9-.3-1.6-.9-2.2-.6-.6-1.3-.9-2.2-.9-.9 0-1.6.3-2.2.9-.6.6-.9 1.3-.9 2.2 0 .9.3 1.6.9 2.2.6.6 1.3.9 2.2.9Zm-1.6-1.4c.4.4 1 .7 1.6.7.6 0 1.2-.2 1.6-.7.4-.4.7-1 .7-1.7s-.2-1.3-.7-1.7c-.4-.4-1-.7-1.6-.7-.6 0-1.2.2-1.6.7-.4.4-.7 1-.7 1.7s.2 1.3.7 1.7ZM76.5 7h-.9v6h.7V8.1l3.1 4.9h.8V7h-.8v4.7L76.5 7ZM47.7 23.1v1.8H52c-.1 1-.5 1.8-1 2.3-.6.6-1.6 1.3-3.3 1.3-2.7 0-4.7-2.1-4.7-4.8 0-2.7 2.1-4.8 4.7-4.8 1.4 0 2.5.6 3.3 1.3l1.3-1.3c-1.1-1-2.5-1.8-4.5-1.8-3.6 0-6.7 3-6.7 6.6 0 3.6 3.1 6.6 6.7 6.6 2 0 3.4-.6 4.6-1.9 1.2-1.2 1.6-2.9 1.6-4.2 0-.4 0-.8-.1-1.1h-6.2Zm11.1-1.3c-2.4 0-4.3 1.8-4.3 4.3 0 2.4 1.9 4.3 4.3 4.3s4.3-1.8 4.3-4.3c0-2.6-1.9-4.3-4.3-4.3Zm5 4.3c0-2.5 1.9-4.3 4.3-4.3s4.3 1.7 4.3 4.3c0 2.5-1.9 4.3-4.3 4.3s-4.3-1.9-4.3-4.3Zm1.9-.1c0 1.5 1.1 2.6 2.4 2.6 1.3 0 2.4-1.1 2.4-2.6 0-1.6-1.1-2.6-2.4-2.6-1.3 0-2.4 1.1-2.4 2.6Zm-9.3 0c0 1.5 1.1 2.6 2.4 2.6 1.3 0 2.4-1.1 2.4-2.6 0-1.6-1.1-2.6-2.4-2.6-1.3 0-2.4 1.1-2.4 2.6Zm33.1-4.2c2.2 0 3.2 1.7 3.6 2.7l.2.5-5.7 2.4c.5.9 1.1 1.3 2.1 1.3s1.6-.5 2.1-1.2l1.4 1c-.4.7-1.6 1.9-3.5 1.9-2.4 0-4.2-1.9-4.2-4.3 0-2.6 1.8-4.3 4-4.3Zm-2.2 4.1c0-1.6 1.3-2.5 2.2-2.5.7 0 1.4.4 1.6.9l-3.8 1.6ZM84.5 30h-1.9V17.5h1.9V30Zm-4.9-7.3c-.5-.5-1.3-1-2.3-1-2.1 0-4.1 1.9-4.1 4.3s1.9 4.2 4.1 4.2c1 0 1.8-.5 2.2-1h.1v.6c0 1.6-.9 2.5-2.3 2.5-1.1 0-1.9-.8-2.1-1.5l-1.6.7c.5 1.1 1.7 2.5 3.8 2.5 2.2 0 4-1.3 4-4.4V22h-1.8v.7ZM75 26c0 1.5 1.1 2.6 2.4 2.6 1.3 0 2.3-1.1 2.3-2.6s-1-2.6-2.3-2.6c-1.3 0-2.4 1.1-2.4 2.6Zm26.8-8.5h-4.5V30h1.9v-4.7h2.6c2.1 0 4.1-1.5 4.1-3.9s-2-3.9-4.1-3.9Zm-2.6 6h2.7c1.3 0 2.1-1.1 2.2-2.2 0-.9-.8-2.1-2.2-2.1h-2.7v4.3Zm14.2-1.8c-1.4 0-2.8.6-3.3 1.9l1.7.7c.4-.7 1-.9 1.7-.9 1 0 1.9.6 2 1.6v.1c-.3-.2-1.1-.5-1.9-.5-1.8 0-3.6 1-3.6 2.8 0 1.7 1.5 2.8 3.1 2.8 1.3 0 1.9-.6 2.4-1.2h.1v1h1.8v-4.8c-.2-2.2-1.9-3.5-4-3.5Zm-1.7 5.8c0 .8.9 1.1 1.5 1.1 1 0 2-.8 2.2-2l-.149-.06c-.436-.178-.832-.34-1.551-.34-.9 0-2 .3-2 1.3Zm12-5.5-2.1 5.4h-.1l-2.2-5.4h-2l3.3 7.6-1.9 4.2h1.9l5.1-11.8h-2Zm-14.9 8h-1.9V17.5h1.9V30Z"
				fill="#fff"
			/>
			<path
				d="M9.523 7.5c-.3.3-.5.8-.5 1.4V31c0 .6.2 1.1.5 1.4l.1.1 12.4-12.4v-.2L9.523 7.5Z"
				fill="url(#DownloadGooglePlay_tsx__b)"
			/>
			<path
				d="m26.123 24.3-4.1-4.1V19.9l4.1-4.1.1.1 4.9 2.8c1.4.8 1.4 2.1 0 2.9l-5 2.7Z"
				fill="url(#DownloadGooglePlay_tsx__c)"
			/>
			<path
				d="m26.223 24.2-4.2-4.2-12.5 12.5c.5.5 1.2.5 2.1.1l14.6-8.4Z"
				fill="url(#DownloadGooglePlay_tsx__d)"
			/>
			<path
				d="m26.223 15.8-14.6-8.3c-.9-.5-1.6-.4-2.1.1l12.5 12.4 4.2-4.2Z"
				fill="url(#DownloadGooglePlay_tsx__e)"
			/>
		</g>
		<defs>
			<linearGradient
				id="DownloadGooglePlay_tsx__b"
				x1={16.559}
				y1={-7.427}
				x2={-3.308}
				y2={-2.055}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#00A0FF" />
				<stop offset={0.007} stopColor="#00A1FF" />
				<stop offset={0.26} stopColor="#00BEFF" />
				<stop offset={0.512} stopColor="#00D2FF" />
				<stop offset={0.76} stopColor="#00DFFF" />
				<stop offset={1} stopColor="#00E3FF" />
			</linearGradient>
			<linearGradient
				id="DownloadGooglePlay_tsx__c"
				x1={32.958}
				y1={9.87}
				x2={8.761}
				y2={9.87}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FFE000" />
				<stop offset={0.409} stopColor="#FFBD00" />
				<stop offset={0.775} stopColor="orange" />
				<stop offset={1} stopColor="#FF9C00" />
			</linearGradient>
			<linearGradient
				id="DownloadGooglePlay_tsx__d"
				x1={9.206}
				y1={13.514}
				x2={-6.759}
				y2={40.318}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FF3A44" />
				<stop offset={1} stopColor="#C31162" />
			</linearGradient>
			<linearGradient
				id="DownloadGooglePlay_tsx__e"
				x1={-0.194}
				y1={4.08}
				x2={6.879}
				y2={16.065}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#32A071" />
				<stop offset={0.069} stopColor="#2DA771" />
				<stop offset={0.476} stopColor="#15CF74" />
				<stop offset={0.801} stopColor="#06E775" />
				<stop offset={1} stopColor="#00F076" />
			</linearGradient>
		</defs>
	</svg>
);
export default DownloadGooglePlay;
